//add video to library
import {RSAA} from "redux-api-middleware";
import {API_ENDPOINT, AUTH_HEADERS, X_AUTHORIZATION} from "../../../util/constants";
import * as types from "../../types";
import {handleUnauthorizedAccess} from "../../../util/utility";

export function subscribeToBroadcaster(token, api_token, data) {
    return {
        [RSAA]: {
            endpoint: `${API_ENDPOINT}/viewer/subscribe?api_token=${api_token}`,
            method: 'POST',
            headers: {
                ...AUTH_HEADERS,
                Authorization: `Bearer ${token}`
            },
            body:JSON.stringify(data),
            types: [types.SUBSCRIBE_TO_BROADCASTER_REQUEST, types.SUBSCRIBE_TO_BROADCASTER_RECEIVE, {
                type: types.SUBSCRIBE_TO_BROADCASTER_FAILURE,
                meta: (action, state, res) => {
                    return handleUnauthorizedAccess(action, state, res);
                }
            }]
        }
    }
}

export const resetSubscribeToBroadcaster = () => ({
    type: types.RESET_SUBSCRIBE_TO_BROADCASTER,
    payload: null
});

/**
 * * * * * * * * * * * * * * * * * * * * * * * * G E T S U B S C R I P T I O N L I S T * * * * * * * * * * * * * * * * * *
 */
export function getSubscriptionList(token, api_token) {
    return {
        [RSAA]: {
            endpoint: `${API_ENDPOINT}/viewer/subscription?api_token=${api_token}`,
            method: 'GET',
            headers: {
                ...AUTH_HEADERS,
                Authorization: `Bearer ${token}`
            },
            types: [types.GET_MY_SUBSCRIPTION_REQUEST, types.GET_MY_SUBSCRIPTION_RECEIVE, {
                type: types.GET_MY_SUBSCRIPTION_FAILURE,
                meta: (action, state, res) => {
                    return handleUnauthorizedAccess(action, state, res);
                }
            }]
        }
    }
}

export const resetGetSubscriptionList = () => ({
    type: types.RESET_GET_MY_SUBSCRIPTION,
    payload: null
});
/**
 * * * * * * * * * * * * * * * * * * * * * * * * G E T S U B S C R I P T I O N L I S T * * * * * * * * * * * * * * * * * *
 */

/**
 * * * * * * * * * * * * * * * * * * * * * * * * C A N C E L S U B S C R I P T I O N * * * * * * * * * * * * * * * * * *
 */
export function cancelSubscription(token, api_token,id,broadcaster_id) {
    let endpoint = '';
    if(broadcaster_id === -1){
        endpoint =  `${API_ENDPOINT}/viewer/cancel/subscription/${id}?api_token=${api_token}`
    }else{
        endpoint =  `${API_ENDPOINT}/viewer/cancel/subscription?broadcaster_id=${broadcaster_id}&api_token=${api_token}`
    }
    return {
        [RSAA]: {
            endpoint,
            method: 'GET',
            headers: {
                ...AUTH_HEADERS,
                Authorization: `Bearer ${token}`
            },
            types: [types.CANCEL_SUBSCRIPTION_REQUEST, types.CANCEL_SUBSCRIPTION_RECEIVE, {
                type: types.CANCEL_SUBSCRIPTION_FAILURE,
                meta: (action, state, res) => {
                    return handleUnauthorizedAccess(action, state, res);
                }
            }]
        }
    }
}

export const resetCancelSubscription = () => ({
    type: types.RESET_CANCEL_SUBSCRIPTION,
    payload: null
});
/**
 * * * * * * * * * * * * * * * * * * * * * * * * C A N C E L S U B S C R I P T I O N * * * * * * * * * * * * * * * * * *
 */



/**
 * * * * * * * * * * * * * * * * * * * * * * * * R E N E W S U B S C R I P T I O N * * * * * * * * * * * * * * * * * *
 */
export function renewSubscription(token, api_token,id) {
    return {
        [RSAA]: {
            endpoint: `${API_ENDPOINT}/viewer/renew/subscription/${id}?api_token=${api_token}`,
            method: 'GET',
            headers: {
                ...AUTH_HEADERS,
                Authorization: `Bearer ${token}`
            },
            types: [types.RENEW_SUBSCRIPTION_REQUEST, types.RENEW_SUBSCRIPTION_RECEIVE, {
                type: types.RENEW_SUBSCRIPTION_FAILURE,
                meta: (action, state, res) => {
                    return handleUnauthorizedAccess(action, state, res);
                }
            }]
        }
    }
}

export const resetRenewSubscription = () => ({
    type: types.RESET_RENEW_SUBSCRIPTION,
    payload: null
});
/**
 * * * * * * * * * * * * * * * * * * * * * * * * R E N E W S U B S C R I P T I O N * * * * * * * * * * * * * * * * * *
 */
